export var DemandForecastingRoutes = {
    "/demand-forecasting?date&step&openAdjustment": {
        "loginRequired": true,
        "name": "appLayout.schedule.demand-forecasting",
        "showGlobalSearch": true,
        "type": "frontend",
        "reloadOnSearch": false,
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Forecasts"
            }
        ],
        "views": {
            "body": {
                component: "demandForecastingComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4",
            styles: ["abs-generation", "mcd-labor", 'gastronomy-labor', 'carrol-labor']
        },
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../activity-based-scheduling/activity-based-scheduling.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../team-live/activity-based-scheduling-generation/activity-based-scheduling-generation.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../team-live/wendys-labor/wendys-labor.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../team-live/mcd-labor/mcd-labor.module.js");
                }
            },

            {
                type: 'chunk',
                loader: function () {
                    return import("../../team-live/gastronomy-labor/gastronomy-labor.module.js");
                }
            },
            {
                type: 'chunk',
                loader: function () {
                    return import("../../team-live/carrol-labor/carrol-labor.module.js");
                }
            }
        ],
        "onEnter": ['$state', 'userServices', 'TeamScheduleService', 'hUser',
                   function ($state, userServices, TeamScheduleService, hUser) {
                TeamScheduleService.getActiveBrand()
                    .then(function (brand) {
                        userServices
                            .isServiceEnabled(userServices.SERVICES.DEMAND_FORECASTING, brand.id)
                            .then(function (isDemandForecastingEnabled) {
                                if (!isDemandForecastingEnabled || !hUser.hasSalesAccess()) {
                                    $state.go("appLayout.schedule.main");
                                }
                            });
                    });
            }]
    },
    "/forecasts-historical-data": {
        "loginRequired": true,
        "name": "appLayout.schedule.forecasts-historical-data",
        "showGlobalSearch": true,
        "type": "frontend",
        "views": {
            "body": {
                component: "forecastsHistoricalDataComponent",
            }
        },
        "route_styles": {
            framework: "bootstrap_v4"
        },
        "headTags": [
            {
                "tag": "title",
                "attributes": {},
                "value": "Harri | Forecasts"
            }
        ],
        "route_dependencies": [
            {
                type: 'chunk',
                loader: function () {
                    return import("../../activity-based-scheduling/activity-based-scheduling.module.js");
                }
            },
        ],
        "onEnter": ['$state', 'hUser', function ($state, hUser) {
            if (!hUser.hasSalesAccess()) {
                $state.go("appLayout.schedule.main");
            }
        }],
    }
};